// @flow
import React, { Component } from 'react';
import _ from 'lodash';
import Waypoint from 'react-waypoint';
import Tooltip from 'react-tooltip';
import Scroll from 'react-scroll';
import I18n from '../../../i18n/I18n';
import Helper from '../../../helper/Helper';
import AsnRow from './asnRow/AsnRow';
import AsnBox from './asnBox/AsnBox';
import { Icon } from '../../common';
import styles from '../../orders/orderTable/OrderTable.scss';

const AsnTable = props => {
    const {
        browser,
        view,
        lang,
        data,
        receivedType,
        transfersType,
        asnType,
        seller,
        history,
        searchString,
        scroll,
        loadFunc,
        lineType,
        scrollLoading,
        imports,
        businessType,
        eligbleEnabled,
        barcodeRecvMethod,
    } = props;

    const receivedShow = receivedType === 2 && transfersType === 2;

    const acceptedShow = receivedType === 2 && transfersType === 1;

    const excessShow = receivedType === 2 && asnType === 1;

    const property = Helper.validator(data);

    const haveItemNr = data && data.find(asn => asn && asn.item_nr);
    const isReceived = data && data.find(asn => asn && asn.is_received);
    const haveReturnAsn =
        data && data.find(asn => asn && asn.return_asn) && isReceived;
    const haveParentAsn = data && data.find(asn => asn && asn.parent_asn);
    const havRefNr = data && data.find(asn => asn && asn.ref_nr);
    const haveStatus = data && data.find(asn => asn && asn.status);

    const asnList =
        data && !_.isEmpty(data)
            ? data.map((asn, index) => (
                  <AsnRow
                      data={asn}
                      eligbleEnabled={eligbleEnabled}
                      acceptedShow={acceptedShow}
                      lang={lang}
                      businessType={businessType}
                      asnType={asnType}
                      transfersType={transfersType}
                      seller={seller}
                      history={history}
                      searchString={searchString}
                      property={property}
                      scroll={scroll}
                      imports={imports}
                      barcodeRecvMethod={barcodeRecvMethod}
                  />
              ))
            : '';

    const loadMoreContent = () => {
        loadFunc();
    };

    const asnBox =
        data && !_.isEmpty(data)
            ? data.map((asn, index) => (
                  <div className={styles.transfersBox}>
                      <AsnBox
                          data={asn}
                          receivedType={receivedShow}
                          acceptedShow={acceptedShow}
                          lang={lang}
                          asnType={asnType}
                          transfersType={transfersType}
                          seller={seller}
                          history={history}
                          searchString={searchString}
                          haveItemNr={haveItemNr}
                          haveReturnAsn={haveReturnAsn}
                          haveParentAsn={haveParentAsn}
                          havRefNr={havRefNr}
                          haveStatus={haveStatus}
                          barcodeRecvMethod={barcodeRecvMethod}
                      />
                  </div>
              ))
            : '';

    return (
        <div className={styles.ctr}>
            {browser &&
            browser.greaterThan[scroll ? 'tablet' : 'desktop'] &&
            view === 'grid' ? (
                <table
                    className={`${styles.table} ${
                        scroll ? styles.scroll : ''
                    } ${styles.transfers}`}
                >
                    <thead>
                        <tr className={`${styles.row} ${styles.head}`}>
                            {property.haveVal('title') ? (
                                <th>{I18n.getText('product-table.name')}</th>
                            ) : (
                                ''
                            )}
                            {property.haveVal('partner_sku') ? (
                                <th>{I18n.getText('product-table.p-sku')}</th>
                            ) : (
                                ''
                            )}
                            {property.haveVal('partner_sku_unique') ? (
                                <th>{I18n.getText('offer.p-sku-unique')}</th>
                            ) : (
                                ''
                            )}
                            {property.haveVal('partner_barcode') &&
                            barcodeRecvMethod ? (
                                <th>{I18n.getText('transfers.partner-barcode')}</th>
                            ) : (
                                ''
                            )}
                            {property.haveVal('sku') && !barcodeRecvMethod ? (
                                <th>{I18n.getText('product-table.sku')}</th>
                            ) : (
                                ''
                            )}
                            {property.haveVal('incoming_skunique') &&
                            imports ? (
                                <th>
                                    {I18n.getText('offer.incoming-sku-unique')}
                                </th>
                            ) : (
                                ''
                            )}
                            {property.haveVal('item_nr') ? (
                                <th>{I18n.getText('order-details.item-nr')}</th>
                            ) : (
                                ''
                            )}
                            {property.haveVal('reason_code') ? (
                                <th>
                                    {I18n.getText('transfers.rejected-reason')}
                                </th>
                            ) : (
                                ''
                            )}
                            {property.haveVal('barcode_box') ? (
                                <th>
                                    {I18n.getText(
                                        'inventory-rejection.box-barcode',
                                    )}
                                </th>
                            ) : (
                                ''
                            )}
                            {property.haveVal('wms_barcode_inner') ? (
                                <th>
                                    {I18n.getText(
                                        'transfers.wms-barcode',
                                    )}
                                </th>
                            ) : (
                                ''
                            )}
                            {property.haveVal('ref_nr') ? (
                                <th>{I18n.getText('transfers.ref-nr')}</th>
                            ) : (
                                ''
                            )}
                            {property.haveQtyVal('qty') ? (
                                <th>{I18n.getText('variants.qty')}</th>
                            ) : (
                                ''
                            )}
                            {property.haveQtyVal('qty_expected') ? (
                                <th>{I18n.getText('transfers.expected')}</th>
                            ) : (
                                ''
                            )}
                            {property.haveQtyVal('qty_recv') ||
                            property.haveQtyVal('qty_received') ? (
                                <th>{I18n.getText('transfers.received')}</th>
                            ) : (
                                ''
                            )}
                            {property.haveQtyVal('qty_rejected') ? (
                                <th>{I18n.getText('transfers.qc-rejected')}</th>
                            ) : (
                                ''
                            )}
                            {property.haveVal('slot') ? (
                                <th>{I18n.getText('transfers.time-slot')}</th>
                            ) : (
                                ''
                            )}
                            {eligbleEnabled ? (
                                <th>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}
                                    >
                                        {I18n.getText('transfers.is-eligible')}
                                        <div
                                            style={{
                                                marginLeft: '5px',
                                                marginRight: '5px',
                                            }}
                                            data-tip
                                            data-for={'eligible'}
                                        >
                                            <Icon
                                                name="tooltip"
                                                className={styles.icon}
                                            />
                                        </div>
                                        <Tooltip
                                            className={styles.tooltip}
                                            place="bottom"
                                            type="dark"
                                            effect="solid"
                                            id={'eligible'}
                                        >
                                            <div>
                                                {I18n.getText(
                                                    'transfers.schedule-eligibility',
                                                )}
                                            </div>
                                        </Tooltip>
                                    </div>
                                </th>
                            ) : (
                                ''
                            )}
                            {property.haveVal('return_asn') ? (
                                <th>{I18n.getText('transfers.return-asn')}</th>
                            ) : (
                                ''
                            )}
                            {property.haveVal('parent_asn') ? (
                                <th>{I18n.getText('transfers.parent-asn')}</th>
                            ) : (
                                ''
                            )}
                            {property.haveVal('warehouse_code') ? (
                                <th>
                                    {I18n.getText(
                                        'product-table.warehouse-code',
                                    )}
                                </th>
                            ) : scroll ? (
                                ''
                            ) : (
                                <th />
                            )}
                            {property.haveQtyVal('incoming_stock') ? (
                                <th>
                                    {I18n.getText(
                                        'product-table.incoming-stock',
                                    )}
                                </th>
                            ) : scroll ? (
                                ''
                            ) : (
                                <th />
                            )}
                            {property.haveVal('incoming_processing_time') ? (
                                <th>
                                    {I18n.getText(
                                        'product-table.processing-time',
                                    )}
                                </th>
                            ) : scroll ? (
                                ''
                            ) : (
                                <th />
                            )}
                            {property.haveVal('status') ? (
                                <th>{I18n.getText('product-table.status')}</th>
                            ) : scroll ? (
                                ''
                            ) : (
                                <th />
                            )}
                            {!scroll ? <th /> : ''}
                        </tr>
                    </thead>
                    <tbody
                        className={
                            lineType === 2 || imports ? styles.rmvPadding : ''
                        }
                    >
                        {asnList}
                        {loadFunc && scroll && scrollLoading ? (
                            <div>
                                <Waypoint onEnter={loadMoreContent} />
                                <div>Loading...</div>
                            </div>
                        ) : (
                            ''
                        )}
                    </tbody>
                </table>
            ) : (
                <div
                    className={`${scroll ? styles.scrollCtr : styles.boxCtr} ${
                        lineType === 2 || imports ? styles.rmvPadding : ''
                    }`}
                >
                    <div>{asnBox}</div>
                    {loadFunc && scroll && scrollLoading ? (
                        <div>
                            <Waypoint onEnter={loadMoreContent} />
                            <div>Loading...</div>
                        </div>
                    ) : (
                        ''
                    )}
                </div>
            )}
        </div>
    );
};

export default AsnTable;



// WEBPACK FOOTER //
// ./src/components/transfers/asnTable/AsnTable.js